__turbopack_context__.v({
  "breadcrumbs": "yrUZCq_breadcrumbs",
  "breadcrumbsItem": "yrUZCq_breadcrumbsItem",
  "breadcrumbsLink": "yrUZCq_breadcrumbsLink",
  "breadcrumbsList": "yrUZCq_breadcrumbsList",
  "commonUse": "yrUZCq_commonUse",
  "container": "yrUZCq_container",
  "demoForm": "yrUZCq_demoForm",
  "h1": "yrUZCq_h1",
  "h2": "yrUZCq_h2",
  "h3": "yrUZCq_h3",
  "hero": "yrUZCq_hero",
  "heroImage": "yrUZCq_heroImage",
  "heroImg": "yrUZCq_heroImg",
  "heroText": "yrUZCq_heroText",
  "lead": "yrUZCq_lead",
  "p": "yrUZCq_p",
  "page": "yrUZCq_page",
  "section": "yrUZCq_section",
  "subSection": "yrUZCq_subSection",
  "tabBtn": "yrUZCq_tabBtn",
  "tabBtnActive": "yrUZCq_tabBtnActive",
  "tabH3": "yrUZCq_tabH3",
  "tabH4": "yrUZCq_tabH4",
  "tabPanel": "yrUZCq_tabPanel",
  "tabsButtons": "yrUZCq_tabsButtons",
  "tabsContent": "yrUZCq_tabsContent",
  "tabsWrapper": "yrUZCq_tabsWrapper",
});
